import React from "react";
import { FormControl } from "react-bootstrap";

export default class ReportsParameterType extends React.Component {
    constructor(props) {
        super(props);
    }    

    handleChange() {
        if (this.props.onChange)
            this.props.onChange(this.inputEl.value);
    }

    render() {
        return (       
            <div className="ap-report-control-dropdown">   
                <FormControl
                    componentClass="select"
                    placeholder="select"
                    onChange={this.handleChange.bind(this)}
                    inputRef={el => this.inputEl = el}>
                    <option value="" selected="true">All</option>
                    <option value="0">Exempt</option>
                    <option value="1">Non-Exempt</option>
                </FormControl>
            </div>
        );
    }
}